import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { apiService } from '../../services/api';

// /relier-google : lien du message de Nexus (chat, Slack). Ouvre tout de suite l'autorisation Google unique (Drive,
// agenda, Gmail) puis Google ramène sur l'accueil.

const ConnectGooglePage = () => {
  const [error, setError] = useState(null);
  useEffect(() => {
    apiService.post('/nexus/notices/google/connect', { return_to: '/' })
      .then(({ authorization_url: url }) => { window.location.assign(url); })
      .catch((err) => setError(err.message || 'La connexion à Google n’a pas pu démarrer.'));
  }, []);
  return (
    <div className="mx-auto max-w-md px-4 py-16 text-center text-sm text-slate-600">
      {error ? <p className="text-rose-600">{error}</p> : (
        <p className="flex items-center justify-center gap-2"><Loader2 size={16} className="animate-spin text-indigo-500" /> Ouverture de Google…</p>
      )}
    </div>
  );
};

export default ConnectGooglePage;
